export const css = {
	root: 'srinsJc-',
	item: 'OydSUCMO',
	complete: '_1-UmcLQk',
	readtime: 'WwMk7qE4',
	indented: 'NSPFbVD-',
	leaf: 'rY-fz68P',
	leafItem: '_3XWkd0a-',
	treeRoot: '-bs0r5yj',
	treeNode: '_2cVyKw24',
	contentWrapper: 'O5X-unYm',
	content: 'gP8TIHXf',
	chip: 'D7rPB-wD',
	chipRoot: 'MqtRQS-L',
	expander: 'BiVYMChR',
	title: 'cnh13s7E',
	video: '-bhYSB8n',
	' _key': 'table-of-contents/toc'
};

export default css;
